import React from 'react';
import { Shield, Unlock, Lightbulb } from 'lucide-react';

const philosophies = [
  {
    icon: Shield,
    title: 'Open spec',
    description: 'The API contract is public. Build your own receiver or use ours.',
  },
  {
    icon: Unlock,
    title: 'No lock-in',
    description: 'Remove AgentD and your agent still works. It\'s just a wrapper.',
  },
  {
    icon: Lightbulb,
    title: 'Start simple',
    description: 'Console output by default. Add infrastructure as you need it.',
  },
];

const PhilosophySection = () => {
  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
            Built on <span className="text-blue-600 dark:text-blue-400">principles</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We believe in transparency, simplicity, and developer freedom.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {philosophies.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center space-y-4 p-8 rounded-xl bg-card border border-border hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 rounded-full bg-blue-500/10 flex items-center justify-center">
                <item.icon className="h-8 w-8 text-blue-600 dark:text-blue-400" />
              </div>
              <h3 className="text-xl font-bold">{item.title}</h3>
              <p className="text-muted-foreground">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;